export const PARTNER = "partnermeldung";
export const VPKN = "vpkn";
export const PRODUCT = "products";
